const LoginRoute = {
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/index.vue'),
}

const IndexRoute = {
  path: '',
  name: 'basic',
  component: () => import('@/layout/Layout.vue'),
  redirect: '/index',
  children: [
    {
      path: '/index',
      name: 'BasicIndex',
      component: () => import('@/views/personal/home/index.vue'),
      meta: {
        id: 'home',
        componentName: 'home',
        keepAlive: true,
        name: '首页',
      },
    },
    {
      path: '/report/production-report',
      redirect: '/report/output-trend',
    },
  ],
}

export default [LoginRoute, IndexRoute]
